import {Component, Input, OnInit} from '@angular/core';
import {Snapshot} from '../../models/snapshot';
import {AirComponentType} from '../../../afb-api/enums/air-component-type.enum';

@Component({
  selector: 'awair-snapshot',
  templateUrl: './snapshot.component.html',
  styleUrls: ['./snapshot.component.scss']
})

export class SnapshotComponent implements OnInit {

  get snapshots(): Snapshot[] {
    if (this._snapshots != null) {
      return this._snapshots;
    }
  }

  @Input()
  set snapshots(value: Snapshot[]) {
    if (value != null) {
      this._snapshots = [...value];
      // Should update current index when device is selected or deselected
      if (this.snapshots.length > 0 && this.snapshots.length !== this.oldSnapshotLength) {
        this.currentIndex = value.length - 1;
      }
      // Get sensor keys of current snapshot
      this.deviceKeys = this.getDeviceKeys(value[this.currentIndex]);
      // Update oldSnapshotLength to compare devices length for next input
      this.oldSnapshotLength = this.snapshots.length;
    }
  }
  private _snapshots: Snapshot[] = [];

  currentIndex: number = 0;
  deviceKeys: AirComponentType[] = [];

  private oldSnapshotLength: number = 0;

  constructor() {
  }

  ngOnInit() {
  }

  onChangeIndex(changedIndex: number): void {
    this.currentIndex = changedIndex;
    this.deviceKeys = this.getDeviceKeys(this.snapshots[changedIndex]);
  }

  private getDeviceKeys(snapshot: Snapshot): AirComponentType[] {
    if (snapshot != null && snapshot.sensors != null) {
      return Object.keys(snapshot.sensors)
      // Should sort in order
        .sort((a: string, b: string) => {
          const mapValue = {temp: 0, humid: 1, co2: 2, voc: 3, dust: 4, pm25: 5, pm10: 6};
          return mapValue[a] - mapValue[b];
        })
        .map((key: string) => <AirComponentType>key);
    }

    return [];
  }
}
